const homeLandingES = {
	hero: {
		title:
			"Bienvenido a Sin Fila — reservas y agenda digital en un solo lugar.",
		subtitle:
			"Visibilidad para negocios. Reservas rápidas para clientes. Todo automático y sin fila.",
		primaryCta: "Soy un negocio",
		secondaryCta: "Descargar App",
		platformText: "Disponible para iOS y Android.",
	},

	about: {
		title: "¿Quiénes somos?",
		paragraph1:
			"Somos Sin Fila, una plataforma dominicana donde negocios y personas se conectan para gestionar y reservar servicios de forma rápida, sencilla y sin fila.",
		paragraph2:
			"Si tienes un negocio, aquí organizas tu agenda digital, automatizas reservas y aumentas tu visibilidad para que más personas te encuentren y reserven contigo. Y como cliente, reservas en segundos, ves horarios disponibles y evitas esperas innecesarias.",
		paragraph3:
			"Un solo lugar para agendar, descubrir y crecer. Todo sin fila.",
	},

	whatWeDo: {
		title: "¿Qué hacemos?",
		description:
			"Sin Fila conecta negocios con clientes mediante reservas digitales simples, rápidas y sin filas.",
	},

	business: {
		title: "Para Negocios",
		intro:
			"Organiza tu agenda, automatiza citas y evita perder clientes.",
		items: [
			"Recibir reservas online 24/7",
			"Confirmaciones automáticas y recordatorios",
			"Horarios claros y sin cruces",
			"Perfil público para conseguir clientes nuevos",
			"Menos tiempo en WhatsApp — más tiempo trabajando",
		],
		cta: "Ir a espacio para negocios",
	},

	clients: {
		title: "Para Clientes",
		intro:
			"Reserva tu cita en segundos, sin llamadas ni espera.",
		items: [
			"Ver disponibilidad real",
			"Reservar al instante",
			"Recibir recordatorios automáticos",
			"Reprogramar o cancelar sin estrés",
			"Encontrar barberías, salones y más cerca de ti",
		],
		cta: "Explorar negocios",
	},

	finalCta: {
		text: "Descarga en Google Play o App Store",
	},
};

export default homeLandingES;
